var upb = { parent: '=' };
var programs = [
    'Promotions', 'Performance Bonus', 'Custom Initiatives',
    'Fees', 'Instant Rebates'
];
var UserEditController = (function () {
    function UserEditController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings) {
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.user = {};
        this.select = { countries: {}, iots: {}, programs: {}, standard_reports: {}, cbg: {}, valid: false };
        this.original = { swdr_permissions: {} }; //for future logging reference at save time
        this.editing = { imts: [] };
        this.isShowClaimForms = false;
        this.isShowCore = false;
        this.isShowMetrics = false;
        this.events = { beingSaved: false };
        this.view = { country: true };
        this.serverError = null;
        this.toggle = { rep: false, cty: false, prg: false };
    }
    UserEditController.prototype.setUp = function () {
        var _this = this;
        this.editing = this.parent.user; //set
        this.setAvailablePrograms();
        angular.copy(this.parent.user, this.original); //for logging etc
        delete this.editing.change_log; //remove the change log from the data to be saved
        //Set all to no.....this could easily be resolved by saving objects in couch
        angular.forEach(this.settings.iot_list, function (iot) {
            _this.select.iots[iot] = false;
        });
        //set the selected permission options based on cloudant data
        this.syncEditingPermissions('iot', 'iots');
        this.syncEditingPermissions('country', 'countries');
        this.syncEditingPermissions('program', 'programs');
        this.syncEditingPermissions('standard_report', 'standard_reports');
        this.standardReports = ['Closed', 'Open']; //Temp...pull from cloudant doc
        this.syncCountries();
    };
    UserEditController.prototype.setAvailablePrograms = function () {
        var userPrograms = _.get(this.editing, 'swdr_permissions.program', []);
        if (userPrograms.includes('SVI')) {
            this.isShowCore = true;
            this.isShowMetrics = true;
        }
        var isIncludesProgramType = userPrograms.filter(function (program) { return programs.includes(program); }).length > 0;
        if (isIncludesProgramType) {
            this.isShowClaimForms = true;
        }
    };
    UserEditController.prototype.syncEditingPermissions = function (object, target) {
        var _this = this;
        angular.forEach(this.editing.swdr_permissions[object], function (value) {
            _this.select[target][value] = true;
        });
    };
    UserEditController.prototype.syncCountries = function () {
        var _this = this;
        var cty = [];
        this.select.cbg = {}; //reset
        //Build array of countries short names only
        angular.forEach(this.select.countries, function (value, key) {
            if (value) {
                cty.push(key);
                //count countries per geo
                var geo = _this.admin.getCountryIOT(key);
                if (_this.select.cbg[geo] === undefined) {
                    _this.select.cbg[geo] = 1;
                }
                else {
                    _this.select.cbg[geo]++;
                }
            }
        });
        this.editing.swdr_permissions.country = cty;
        this.validateIOTs();
    };
    UserEditController.prototype.validateIOTs = function () {
        var _this = this;
        //Validate selections
        var valid = true;
        if (Object.keys(this.select.iots).length > 0) {
            //Loop through the selected IOTs
            angular.forEach(this.select.iots, function (value, key) {
                //If enabled but no selections made
                if (value && angular.isUndefined(_this.select.cbg[key])) {
                    valid = false; //not valid
                }
            });
        }
        this.select.valid = valid;
    };
    UserEditController.prototype.syncPrograms = function () {
        var prg = [];
        //Build array of countries short names only
        angular.forEach(this.select.programs, function (value, key) {
            if (value) {
                prg.push(key);
            }
        });
        this.editing.swdr_permissions.program = prg;
    };
    UserEditController.prototype.syncReports = function () {
        var rep = [];
        //Build array of countries short names only
        angular.forEach(this.select.standard_reports, function (value, key) {
            if (value) {
                rep.push(key);
            }
        });
        this.editing.swdr_permissions.standard_report = rep;
    };
    UserEditController.prototype.selectAll = function (iot) {
        var _this = this;
        //Loop through the countries
        angular.forEach(this.settings.country_list, function (cty) {
            //If the iot matches...add it
            if (iot === cty.imt && cty.ic === 'Country') {
                _this.select.countries[cty.short] = true;
            }
        });
        this.syncCountries();
    };
    UserEditController.prototype.deselectAll = function (iot) {
        var _this = this;
        //Loop through the selected countries
        angular.forEach(this.select.countries, function (value, key) {
            //If the iot matches...lose it
            if (iot === _this.admin.getCountryIOT(key)) {
                _this.select.countries[key] = false;
            }
        });
        this.syncCountries();
    };
    /**
     * refreshIOTs - Function called when an IOT is enabled or disabled.  This will rebuild the
     * list of iots for the checkbox and to be saved in the editing data
     */
    UserEditController.prototype.refreshIOTs = function (enabled, iot) {
        if (!enabled) {
            this.deselectAll(iot);
        }
        var iots = [];
        angular.forEach(this.select.iots, function (value, key) {
            if (value) {
                iots.push(key);
            }
        });
        this.editing.swdr_permissions.iot = iots;
        this.validateIOTs();
    };
    UserEditController.prototype.$onInit = function () {
        this.setUp();
    };
    UserEditController.prototype.getChangeValues = function (data) {
        var v = data;
        if (angular.isArray(v)) {
            v = data.toString().replace(/,/g, ', ');
        }
        else if (data === true) {
            v = 'Yes';
        }
        else if (data === false) {
            v = 'No';
        }
        if (v === '' || angular.isUndefined(v) || v.length === 0) {
            v = '-';
        }
        return v;
    };
    UserEditController.prototype.getChangeLog = function () {
        var _this = this;
        var clPack = {
            changes: {},
            timestamp: new Date().getTime(),
            user: this.env.user.email
        };
        var changes = {};
        var count = 0;
        var fields = ['iot', 'country', 'program',
            'standard_report', 'general_report', 'pivot_report', 'custom_report', 'shared_report', 'app'];
        angular.forEach(fields, function (field) {
            if (!angular.equals(_this.original.swdr_permissions[field], _this.editing.swdr_permissions[field])) {
                var o = _this.getChangeValues(_this.original.swdr_permissions[field]);
                var n = _this.getChangeValues(_this.editing.swdr_permissions[field]);
                clPack.changes[field] = { old: o, new: n };
            }
        });
        return clPack;
    };
    /**
     * save - Function triggered when user clicks the Save button.
     *
     * @param  {type} event: any Browser event for the benefit of the display prompts (if needed)
     */
    UserEditController.prototype.save = function (event) {
        var _this = this;
        this.events.beingSaved = true; //set flag to disable save button
        this.serverError = null;
        var saveBundle = { data: this.editing, changelog: this.getChangeLog() };
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.savePromise(saveBundle).then(function (data) {
            //If response from server received
            _this.events.beingSaved = false; //enable save again
            if (data.error) {
                _this.serverError = data.error;
            }
            else {
                _this.admin.navigate('admin.users-view');
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.';
        });
    };
    UserEditController.prototype.savePromise = function (saveBundle) {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs
        this.admin.updateUserProfile(saveBundle);
        // TO DO
        this.socket.forward('config.user_update', this.$scope);
        this.$scope.$on('socket:config.user_update', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    UserEditController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state',
        'socket', '$scope', 'config', 'admin', '$timeout', 'Dialog', '$q', 'settings'];
    return UserEditController;
}());
var UserEditComponent = (function () {
    function UserEditComponent() {
        this.bindings = upb; //Bindings to connect with parent
        this.templateUrl = 'user.html';
        //controllerAs = 'vm';  //No controller required...$ctrl becomes the controller by default as this is a child
        this.controller = UserEditController;
    }
    return UserEditComponent;
}());
angular
    .module('application')
    .component('adminUserSection', new UserEditComponent());

//# sourceMappingURL=user.edit.component.js.map
